module.exports = __webpack_public_path__ + "static/media/_Veg.5aa5fc6e.png";